<template>
  <div id="app">
    <img src="@/assets/logo-tenc.svg" class="logo" />
    <SheetToCsvConverter msg="Size Chart – export CSV" />
  </div>
</template>

<script>
import SheetToCsvConverter from "./components/SheetToCsvConverter.vue";

export default {
  name: "App",
  components: {
    SheetToCsvConverter,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ccc;
  margin-top: 60px;
}
body {
  background-color: #aaa;
}
.logo {
  width: 300px;
}
</style>
